import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { AiOutlineArrowRight } from 'react-icons/ai'
import CustomDialog from '../CustomDialog'
import HeadingWithCloseIcon from '../HeadingWithCloseIcon'

export default function ListDialog({ array, handleClose, open, name, heading, name2, field2 }) {
  const [state, setstate] = useState([])
  //console.log('Array : ', array)
  useEffect(() => {
    if (array) {
      setstate(array)
    }
  }, [array])

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <HeadingWithCloseIcon heading={heading} handleClose={handleClose} />
      {/* <h5> Products </h5> */}
      {state.length > 0 ? (
        state.map((val, index) => {
          return (
            <List key={index}>
              <ListItem>
                <ListItemIcon>
                  <AiOutlineArrowRight fontSize="large" />
                </ListItemIcon>
                <ListItemText>{name2 ? `${val[name][name2]} / ${val[name][field2]}` : field2 ? `${val[name]}/${val[field2]}` : val[name]}</ListItemText>
              </ListItem>
            </List>
          )
        })
      ) : (
        <Typography variant="h1" color="initial">
          {' '}
          No Data Found{' '}
        </Typography>
      )}
    </CustomDialog>
  )
}
